import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export interface FormSubjectOption {
  value: string;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'form-subject-field',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createBlock(_component_a_form_item, {
    class: "form-subject-field stc-ant-field-skin",
    label: "Тема обращения",
    name: "subject",
    required: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_select, {
        class: "form-subject-field__select",
        value: __props.modelValue,
        placeholder: "Выберите тему",
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event)))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (opt) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: opt.value,
              value: opt.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(opt.label), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})